import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteShippingServiceWorkingCenterProps extends ModalEditComponentProps { }

const ModalDeleteShippingServiceWorkingCenter: React.FC<ModalDeleteShippingServiceWorkingCenterProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCenter/workingCenterShippingService/deleteWorkingCenterShippingService',
        data: {
            ShippingServiceId: allRowData?.ShippingServiceId,
            WorkingCenterId: allRowData?.WorkingCenterId,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteShippingServiceWorkingCenter', '¿Seguro quieres eliminar este servicio de transporte de este Centro de trabajo?'),
            subtitle: t('onceDeletedNotRecoverF', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteShippingServiceWorkingCenter